import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { ImmigrationDelegate } from "../Immigration/immigration.delegate";
import { ImmigrationService } from "../Immigration/immigration.service"
export class ImmigrationServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService): ImmigrationService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new ImmigrationDelegate(config, httpProvider);

        return new ImmigrationService(delegate, authenticationService);
    }
}